<template>
  <BaseModal :title="`${context.projectName} ${$t('description')}`">
    <span class="break-word">{{ context.projectDescription }}</span>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';

  export default {
    name: 'DescriptionModal',
    components: { BaseModal },
    props: {
      context: {
        type: Object,
        default: () => ({
          projectName: String,
          projectDescription: String,
        }),
      },
    },
  };
</script>
